/**
 * @name results.controller:MainCtrl
 * @description
 * # MainCtrl
 * Controller of the app
 */
export default () => {
    'ngInject';
};



// WEBPACK FOOTER //
// ./src/js/controllers/main.js